import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button  } from 'react-bootstrap';
import { fetchPlatforms, fetchPlatformBands } from '../../store/actions/platforms/platformActions';
import { updateProjectScope, 
  computeTotals,
  computeBlendedRate, 
  fetchProjectScope, 
  updatePlatformBand, 
  resetBlendedRates, 
  setInitialScope, 
  roundOffManHours, 
  combineTaskDistributionAndBands, 
  saveProjectCosting } from '../../store/actions/projects/projectCostingActions';
import { setIsModifyingCost, 
  handleFieldChange, 
  upsertProject, 
  CREATE_PROJECT, 
  PENDING, 
  UPDATE_PROJECT} from '../../store/actions/projects/projectsActions';
import { WORK_HOURS } from '../../store/actions/timesheet/timesheetActions';
import ProgressingButton from '../../common/ProgressingButton';
import { PROJECT_SPONSOR, PROJECT_ADMIN, FINANCE_APPROVER, PORTAL_ADMIN, MANAGER, TEAM_LEADER } from '../../store/actions/users/usersActions';
import { resetIsSaving, setIsSaving, toggleShowAlert, ERROR_ALERT, SUCCESS_ALERT } from '../../store/actions/commonActions';

import PlatformCard from './PlatformCard';
import ProjectCostingHeader from './ProjectCostingHeader';
import ProfitAndLoss from './ProfitAndLoss';
import ExternalCost from './ExternalCost';
import { Cache } from 'aws-amplify';
import moment from 'moment';

class ProjectCosting extends Component {

  constructor(props) {
    super(props);
    this.project = {}

    this.platforms = [];
    this.platformBands = [];
    this.costingTotals = [];
  }

  componentDidMount() {
    const roleId = Cache.getItem('roleId');
    const allowedRoles = [
      PROJECT_ADMIN, 
      PROJECT_SPONSOR, 
      FINANCE_APPROVER, 
      PORTAL_ADMIN,
      MANAGER,
      TEAM_LEADER
    ];

    if (!allowedRoles.includes(roleId)) {
      this.props.history.push('/dashboard');
    }

    this.props.resetBlendedRates();
    this.props.resetIsSaving();
    if (this.props.inWizard && this.props.action === CREATE_PROJECT) {
      this.props.setInitialScope(this.props.project.platform);
    }

    const platforms = this.props.project.platform; 

    this.props.fetchPlatforms({id: platforms}, true);
    this.props.fetchPlatformBands({
      platform_id: platforms, 
      fully_loaded: this.props.project.fully_loaded,  
      year: this.props.project.costing_year ? this.props.project.costing_year : moment().year()}, true, 
      () => {
        platforms.length && platforms.forEach(platform => {
          this.props.combineTaskDistributionAndBands(platform)
      }) 
    });

    if (this.props.action === UPDATE_PROJECT) {
      this.props.fetchProjectScope({project_id: this.props.project.id}, this.props.project.platform);
    }
    
    this.disableSubmit = true;

    document.getElementsByClassName("num-input").value = "";
  }

  componentWillUnmount() {
  }

  calculateScope = (e, platform) => {
    let mandays = parseFloat(e.target.value);
    if (!mandays) {
      mandays = 0;
    }

    let scopes = this.props.projects.projScoping;
    const band = e.target.id;
    let manhours = mandays * WORK_HOURS;

    scopes = scopes.map(scope => {
      if (scope.platform_id === platform.id) {
        if (scope.band_group === band) {
          scope.mandays = mandays;
          scope.manhours = manhours;
        }
      }

      return scope;
    })

    //get total man hours
    let totalManhours = 0;
    scopes.forEach(scope => {
      if (scope.platform_id === platform.id) {
        totalManhours += scope.manhours
      }
    })

    scopes = scopes.map(scope => {
      if (scope.platform_id === platform.id) {
        scope.percentage = parseFloat(((scope.manhours / totalManhours) * 100).toFixed(2));
      }
      return scope;
    })

    this.disableSubmit = false;
    this.props.updateProjectScope(scopes);
  }

  calculateBandCost = (e, platformBand) => {
    let projPlatformBands = this.props.projects.projPlatformBands;
    let costingTotals = this.props.projects.costingTotals;
    let bandId = 0;
    let taskDistribution = 0;
    let totalManhours = 0;
    let totalCostPerBand = 0;
    let totalBandManHours = 0;

    projPlatformBands.length && projPlatformBands.forEach(projPlatformBand => {
      if (projPlatformBand.id === platformBand.id) {
        bandId = platformBand.id;
        taskDistribution = parseFloat(e.target.value);
        if (isNaN(taskDistribution)) {
          taskDistribution = 0;
        }
        if (taskDistribution) {
          costingTotals.length && costingTotals.forEach(costingTotal => {
            if (costingTotal.platformId === projPlatformBand.platform_id) {
              totalManhours = costingTotal.totalManhours;
            }
          })

          totalBandManHours = (taskDistribution / 100) * totalManhours;
          totalBandManHours = roundOffManHours(parseFloat(totalBandManHours.toFixed(2)));
          totalCostPerBand = totalBandManHours * projPlatformBand.cost;
        }
      }
    })
    this.props.setIsModifyingCost(true);
    this.props.updatePlatformBand(bandId, taskDistribution, totalBandManHours, totalCostPerBand);
    this.props.computeBlendedRate(platformBand.platform_id, true);
    this.disableSubmit = false;
  }

  renderPlatformCards = () => {
    let platformCards = [];
    
    let projPlatforms = this.props.projects.projPlatforms;
    let projPlatformBands = this.props.projects.projPlatformBands;
    let projectScopes = this.props.projects.projScoping;
    let costingTotals = this.props.projects.costingTotals;
    let project = this.props.projects.project;

    if (!projPlatforms) {
      return <p className="text-danger">Please select platforms.</p>
    }

    platformCards = projPlatforms.length && projPlatforms.map((projPlatform, key) => {
      let bands = [];
      if (projPlatformBands) {
        bands = projPlatformBands.filter(data => {
          if (data.platform_id === projPlatform.id) {
            return data;
          }
          return false;
        }).map(platformBand => {
          return platformBand;
        })
      }
      else {
        bands = null;
      }
      
      return <PlatformCard 
              key={key} 
              project={project} 
              newDetails={this.props.newDetails} 
              forApproval={this.props.forApproval} //deets for approval
              platform={projPlatform} 
              bands={bands} 
              scopes={projectScopes} 
              costingTotals={costingTotals}
              onCalculate={this.calculateScope} 
              onAddBandCosts={this.calculateBandCost} 
              computeTotals={this.props.computeTotals} 
              readOnly={this.props.readOnly} 
              />
    })

    this.platforms = projPlatforms;
    this.platformBands = projPlatformBands;

    if (platformCards.length) {
      return platformCards;
    }
    else {
      platformCards = "Loading..."

      return platformCards
    }
  }

  showInvalidAlert = (message) => {
    this.props.toggleShowAlert(true, ERROR_ALERT, message);
  }

  render() {
    let projPlatforms = this.props.projects.projPlatforms;
    
    if (!projPlatforms) {
      return <p className="text-danger">Please select platforms.</p>
    }

    let project = this.props.project;

    let clientName = '';
    let projectName = '';
    let projectCode = '';
    let projectRevenue = 0;
    let externalCost = 0;
    //let projectRevenue = 0;
    let fullyLoadedCost = 0;
    let createdBy = '';
    let createdAt = '';
    let costingYear = '';

    if (project.is_disabled && typeof(this.props.readOnly) === "undefined") {
      this.props.toggleShowAlert(true, ERROR_ALERT, 'You are not allowed to perform this action.');
      this.props.history.push('/projects/disabled');
    }

    if (typeof(project.client) !== "undefined") {
      const client = project.client;
      if (client) {
        clientName = client.client_name;
      }
    }
    else {
      clientName = project.client_name;
    }

    if (typeof(project.project_name) !== "undefined") {
      projectName = project.project_name;
    }

    if (typeof(project.project_code) !== "undefined") {
      projectCode = project.project_code;
    }

    if (typeof(project.project_revenue) !== "undefined") {
      projectRevenue = project.project_revenue || 0;
    }
    
    if (typeof(project.fully_loaded_cost) !== "undefined") {
      fullyLoadedCost = +project.fully_loaded_cost || 0;
    }

    if (typeof(project.project_external_cost) !== "undefined") {
      externalCost = project.project_external_cost || 0;
    }

    if (typeof(project.costing_year) !== "undefined") {
      costingYear = project.costing_year;
    }
    else {
      this.props.handleFieldChange(null, {
        costing_year: moment().year()
      });
    }

    /*
    if (typeof(project.project_revenue) !== "undefined") {
      projectRevenue = project.project_revenue || 0;
    }
    */

    if (typeof(project.created_by) !== "undefined") {
      const user = project.created_by;
      if (Object.keys(user).length) {
        createdBy = user.first_name + " " + user.last_name;
      }
    }

    if (project.created_at) {
      createdAt = project.created_at;
    }

    let costingTotals = this.props.projects.costingTotals;
    
    const onChangeExternalCost = (e) => {
      let externalCost = e.target.value;
      if (!externalCost) {
        externalCost = 0;
      }
      externalCost = parseFloat(externalCost);
      this.props.handleFieldChange(null, {
        project_external_cost: externalCost
      });
    }
    
    const onChangeCostingYear = (costingYear) => {
      if (costingYear) {
        this.props.handleFieldChange(null, {
          costing_year: costingYear.value
        });
        this.props.fetchPlatformBands({
          platform_id: project.platform,
          fully_loaded: project.fully_loaded,  
          year: costingYear.value}, true);
      }
    }

    /*
    const onChangeRevenue = (e) => {
      let projectRevenue = e.target.value;
      if (!projectRevenue) {
        projectRevenue = 0;
      }
      projectRevenue = parseFloat(projectRevenue);
      this.props.handleFieldChange(null, {
        project_revenue: projectRevenue
      });
    }
    */

    if(project.status === PENDING) {
      this.disableSubmit = true;
    }

    return (
      <>
        <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h6>Project Costing Worksheet</h6>
          </Col>
        </Row>
        <hr />
        <Row className="mt-3">
          <Col>
            <ProjectCostingHeader 
              clientName={clientName} 
              projectName={projectName}
              costingYear={costingYear}  
              requestedBy={createdBy} 
              createdAt={createdAt}
              projectCode={projectCode} 
              platforms={this.platforms} 
              costingTotals={costingTotals} 
              readOnly={this.props.readOnly} 
              onChangeCostingYear= {(e) => {
                onChangeCostingYear(e)
              }} />
            { this.renderPlatformCards() } 
            {<ExternalCost 
              externalCost={externalCost} 
              showInvalidAlert={this.showInvalidAlert}
              onChangeExternalCost={(e) => {
                this.disableSubmit = false;
                onChangeExternalCost(e);
              }} 
              readOnly={this.props.readOnly} 
              />}
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <ProfitAndLoss 
              projectRevenue={projectRevenue}
              fullyLoadedCost={fullyLoadedCost}
              externalCost={externalCost} 
              isFullyLoaded={project.fully_loaded} 
              //projectRevenue={projectRevenue} 
              //onChangeRevenue={onChangeRevenue} 
              readOnly={this.props.readOnly}  
              />
          </Col>
        </Row>
        {!this.props.inWizard && !this.props.readOnly && <Row className="mt-3">
          <Col>
            <div className="float-right">
              <Button variant="default" onClick={() => {
                this.props.history.push('/projects');
              }}>
                Cancel 
              </Button>
              <ProgressingButton 
                variant="primary" 
                disabled={this.disableSubmit}
                buttonValue="Send to Approvers" 
                onClick={async () => {
                  this.props.setIsSaving(true);
                  await this.props.saveProjectCosting();
                  this.props.upsertProject('UPDATE_PROJECT', () => {
                    this.props.setIsSaving(false);
                    this.props.history.push('/projects/view?id=' + project.id);
                    this.props.toggleShowAlert(true, SUCCESS_ALERT, "Project Costings has been successfully sent to approvers.");
                    window.scrollTo(0, 0);
                  }, false, false);
                }} />
            </div>
          </Col>
        </Row> }
      </>
    )
  }
}


const mapStateToProps = (state) => ({
  projects: state.projects,
  platforms: state.platforms,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    updateProjectScope: (...args) => dispatch(updateProjectScope(...args)),
    computeTotals: () => dispatch(computeTotals()),
    saveProjectCosting: () => dispatch(saveProjectCosting()),
    fetchPlatforms: (...args) => dispatch(fetchPlatforms(...args)),
    fetchPlatformBands: (...args) => dispatch(fetchPlatformBands(...args)),
    updatePlatformBand: (...args) => dispatch(updatePlatformBand(...args)), 
    setInitialScope: (...args) => dispatch(setInitialScope(...args)),
    setIsModifyingCost: (...args) => dispatch(setIsModifyingCost(...args)),
    computeBlendedRate: (...args) => dispatch(computeBlendedRate(...args)),
    resetBlendedRates: () => dispatch(resetBlendedRates()),
    handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
    upsertProject: (...args) => dispatch(upsertProject(...args)),
    resetIsSaving: () => dispatch(resetIsSaving()), 
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    setIsSaving: (...args) => dispatch(setIsSaving(...args)),
    fetchProjectScope: (...args) => dispatch(fetchProjectScope(...args)),
    combineTaskDistributionAndBands: (...args) => dispatch(combineTaskDistributionAndBands(...args)) 
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectCosting))
